import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcMediaXls = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.828 2 27 7.555V30H5V2h15.828ZM19 4H7v24h18V10h-6V4ZM21 4.845V8h3.506L21 4.845Z"
      fill="currentColor"
    />
    {/* Lettera X */}
    <path
      d="M9 14h1.2l1.1 1.6 1.1-1.6h1.2l-1.7 2.4 1.8 2.464h-1.2l-1.2-1.696-1.2 1.696H9l1.8-2.464L9 14Z"
      fill="currentColor"
    />
    {/* Lettera L */}
    <path d="M15 14h1v3.4h2.4v0.8H15V14Z" fill="currentColor" />
    {/* Lettera S */}
    <path
      d="M21.8 14.1c0.8 0 1.4.3 1.8.8l-0.7.5c-0.2-.3-.6-.5-1.1-.5-0.6 0-1 .2-1 .6 0 .3.2.4.7.5l0.7.2c0.9.2 1.4.6 1.4 1.4 0 0.5-.2.9-.6 1.2-.4.3-.9.5-1.5.5-0.9 0-1.6-.3-2-.9l0.7-.5c0.3.4.8.6 1.3.6 0.3 0 .6-.1.8-.2.2-.1.3-.3.3-.5 0-.3-.2-.4-.7-.6l-0.7-.2c-0.9-.2-1.4-.7-1.4-1.4 0-.5.2-.9.6-1.1.4-.3.9-.5 1.5-.5Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgIcMediaXls;
